module.exports = __webpack_public_path__ + "static/media/bloating-copy.b205498e.svg";